import * as React from 'react';
import { createSvgIcon } from '@mui/material';

export const Table = createSvgIcon(
  <svg id="Layer_1" viewBox="0 0 48 48" x="0px" y="0px" version="1.1">
    <g id="table">
      <g id="Group-6" transform="translate(2 4)">
        <g id="Group" transform="translate(22 19.5556) rotate(180) translate(-22 -19.5556)">
          <g id="Rectangle-Copy-23">
            <g>
              <path d="M 0 0 h 44 v 39.1 H 0 V 0 Z M 43.5 0.5 h -43 v 38.1 h 43 V 0.5 Z" />
            </g>
          </g>
          <g id="Line-2">
            <rect x="1.6" y="4.6" width="42.1" height="0.5" />
          </g>
          <g id="Line-2-Copy">
            <rect x="1.6" y="9.5" width="42.1" height="0.5" />
          </g>
          <g id="Line-2-Copy-2">
            <rect x="1.6" y="14.4" width="42.1" height="0.5" />
          </g>
          <g id="Line-2-Copy-3">
            <rect x="1.6" y="19.3" width="42.1" height="0.5" />
          </g>
          <g id="Line-2-Copy-4">
            <rect x="1.6" y="24.2" width="42.1" height="0.5" />
          </g>
          <g id="Line-2-Copy-5">
            <rect x="1.6" y="29.1" width="42.1" height="0.5" />
          </g>
          <g id="Line-2-Copy-6">
            <rect x="1.6" y="34" width="42.1" height="0.5" />
          </g>
          <g id="Line-2_1_">
            <rect x="5.9" y="1" width="0.5" height="37.2" />
          </g>
          <g id="Line-2-Copy-7">
            <rect x="10.8" y="1" width="0.5" height="37.2" />
          </g>
          <g id="Line-2-Copy-8">
            <rect x="15.6" y="1" width="0.5" height="37.2" />
          </g>
          <g id="Line-2-Copy-9">
            <rect x="20.5" y="1" width="0.5" height="37.2" />
          </g>
          <g id="Line-2-Copy-10">
            <rect x="25.4" y="1" width="0.5" height="37.2" />
          </g>
          <g id="Line-2-Copy-11">
            <rect x="30.3" y="1" width="0.5" height="37.2" />
          </g>
        </g>
      </g>
    </g>
  </svg>,
  'Table'
);
